const e = "_imageOverlay_1wac0_1", a = "_fullWidthVideoWrapper_1wac0_10", l = "_enableImageOverlay_1wac0_18", t = "_fullWidthVideo_1wac0_10", o = "_pauseButton_1wac0_27", i = {
  imageOverlay: e,
  fullWidthVideoWrapper: a,
  enableImageOverlay: l,
  fullWidthVideo: t,
  pauseButton: o
};
export {
  i as default,
  l as enableImageOverlay,
  t as fullWidthVideo,
  a as fullWidthVideoWrapper,
  e as imageOverlay,
  o as pauseButton
};
